import React, { useState } from "react";
import { Box, TextField, Button, MenuItem, FormControlLabel, Switch } from "@mui/material";
import { ClassListArray } from "../Common/Component/CommonComponents";
import { API_ADD_CLASS_FEE_BOOK_PRICE } from "../Config/ApiUrlConstant";
import { useAuth } from "../AuthContext";

const ClassFeeForm = ({ onSuccess }) => {
    const [formData, setFormData] = useState({
        class_no: "",
        fee_amt: "",
        book_amt: "",
        session: "2025-26",
        is_active: true,
    });
    const [message, setMessage] = useState('');

    const { logout } = useAuth(); // Add this at the top inside the component

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(API_ADD_CLASS_FEE_BOOK_PRICE, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(formData), // ✅ Send as JSON
            });

            const responseData = await response.json();

            if (response.status === 401 || response.status === 403) {
                logout();
                return;
            }
            if (responseData.status) {
                setMessage(responseData.message);
                resetForm();
                if (onSuccess) onSuccess();
            } else {
                setMessage(responseData.message || 'Something went wrong.');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Error adding student.');
        }
    };


    const resetForm = () => {
        setFormData({
            class_no: "",
            fee_amt: "",
            book_amt: "",
            session: "2025-26",
            is_active: true,
        });
    }

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, p: 2 }}>
            <TextField
                label="Class"
                name="class_no"
                value={formData.class_no}
                onChange={handleChange}
                fullWidth
                margin="normal"
                select
            >
                {ClassListArray.map(cls => (
                    <MenuItem key={cls.value} value={cls.value} style={{ minWidth: '100px' }}>{cls.name}</MenuItem>
                ))}
            </TextField>

            <TextField
                label="Fee Amount"
                name="fee_amt"
                type="number"
                value={formData.fee_amt}
                onChange={handleChange}
                fullWidth
                margin="normal"
            />

            <TextField
                label="Book Amount"
                name="book_amt"
                type="number"
                value={formData.book_amt}
                onChange={handleChange}
                fullWidth
                margin="normal"
            />

            <TextField
                label="Session"
                name="session"
                value={formData.session}
                onChange={handleChange}
                fullWidth
                margin="normal"
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={formData.is_active}
                        onChange={(e) =>
                            setFormData({ ...formData, is_active: e.target.checked })
                        }
                        name="is_active"
                    />
                }
                label="Active"
            />

            <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }}>
                Save
            </Button>
        </Box>
    );
};

export default ClassFeeForm;
